import React, { Component } from 'react'
import { connect } from 'react-redux'
import {compose } from 'recompose'
import * as routes from '../../../../constants/routes';
import { withRouter } from 'react-router-dom';
import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
//import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import Badge from '@material-ui/core/Badge';
import Contacts from '@material-ui/icons/Contacts';
import { styles } from '../../stylesAdminCanidateList'
import { CURRENT_OPEN_EVENT } from '../../../../constants/actionTypes'
import Grid from '@material-ui/core/Grid'
import { defaultGridSettings } from '../../../../js/settings/grid'
import { getDateFormated } from '../../../../js/helper'
import ConnectedEvents from './ConnectedEvents'
import ConfirmedEvents from './ConfirmedEvents'
//const arraySort = require('array-sort');

class AdminGridList extends Component {
   

   async componentDidMount() {

    }
    toggleView = (canidateEvent) => {
     
        const { history, onOpenAdminCanidateDetails } = this.props
        onOpenAdminCanidateDetails(canidateEvent)
        history.push(routes.ADMINCANIDATEDETAILS)
    }

    render () {
        const { classes,  events, type, toggleView} = this.props
        if(events===null)return null

        //const eventsCounter = Object.keys(events).length -1
        return (      
            <Grid container {...defaultGridSettings.container} >
                    {events.map((event) => {
                        const canidatesOnWaitCounter = Object.keys(event.canidatesOnWait).length -1
                        return (
                            <Grid key={event.event.id} item {...defaultGridSettings.item} >
                                <Paper 
                                    className={classes.paper}
                                    onClick={()=>toggleView('details', event)}
                                        >
                                    <div className={classes.header}>
                                        <Typography color='inherit' variant='subheading'>
                                            <div className={classes.requester.name}>{event.requester.requesterName}</div>
                                        </Typography>
                                    </div>
                                    <div className={classes.body}>
                                        <Typography variant='body2'>
                                            <div className={classes.row}>sucht für {event.event.task} </div>
                                            <div className={classes.row}>in {event.event.ort}</div>
                                        </Typography>
                                        <Typography variant='body2'>
                                            {event.event.timeRange==='onData'
                                                        ? <span style={styles.red}>An einem bestimmten Datum</span>
                                                        : <span>Nach Vereinbarung bis zum: </span>
                                            }
                                            <span>{getDateFormated(event.event.date, 'withWeekDay')}</span>
                                        </Typography>
                                        {type==='connected'
                                            ? <ConnectedEvents event={event} classes={classes} />
                                            : <ConfirmedEvents event={event} classes={classes} />
                                        }
                                    </div>
                                    <div className={classes.paperFooter}>
                                        <div className={classes.timeLeft }>
                                            Läuft ab  {getDateFormated(event.event.date, 'untilThen')}
                                        </div>
                                        <div style={{display: 'inline-block'}}>
                                            <Badge badgeContent={canidatesOnWaitCounter} color="primary">
                                                <Contacts color='primary'/>
                                            </Badge>
                                        </div>
                                    </div>
                                </Paper>
                            </Grid>
                        )
                    })}
                        
                </Grid>
        )
    }
}

const mapStateToProps = (state) => ({
    canidateEvents: state.adminCanidateState.canidateList,
    requester: state.adminCanidateState.requester,
    currentOpenEvent: state.adminCanidateState.currentOpenEvent.data

})

const mapDispatchToProps = (dispatch) =>({
    //onFetchAdminCanidateList: ()=>fetchAdminCanidateList(),
    onOpenAdminCanidateDetails: (payload)=>dispatch({type: CURRENT_OPEN_EVENT, payload})
})

    

    
    export default compose(
        connect(mapStateToProps, mapDispatchToProps),
        withStyles(styles),
        withRouter,
    )(AdminGridList)


// WEBPACK FOOTER //
// ./src/Components/Admin/AdminEvents/View/AdminGridList.js